/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cuddly_Awake_Fireant_LiftInputs */

const fr_cuddly_awake_fireant_lift = /** @type {(inputs: Cuddly_Awake_Fireant_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner un type de record`)
};

/**

* @param {Cuddly_Awake_Fireant_LiftInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const cuddly_awake_fireant_lift = /** @type {((inputs?: Cuddly_Awake_Fireant_LiftInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cuddly_Awake_Fireant_LiftInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_cuddly_awake_fireant_lift(inputs)
});